import { render, staticRenderFns } from "./import-substitution-reply-create.vue?vue&type=template&id=5524cbbe&"
import script from "./import-substitution-reply-create.vue?vue&type=script&lang=js&"
export * from "./import-substitution-reply-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5524cbbe')) {
      api.createRecord('5524cbbe', component.options)
    } else {
      api.reload('5524cbbe', component.options)
    }
    module.hot.accept("./import-substitution-reply-create.vue?vue&type=template&id=5524cbbe&", function () {
      api.rerender('5524cbbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/import-substitution/import-substitution-reply-create.vue"
export default component.exports